<template>
  <loading-view :loading="loading || !(integration1 && integration2)">
    <div class="grid-3 px-4 justify-content-center align-items-center" :class="{'tile mt-4 mb-8 p-4' : !simple }">
      <integration-card :integration="integration1" :simple="simple"/>
      <div class="px-8 text-center" :class="{'py-6' : !simple }">
        <svg class="icon icon_arrows">
          <use xlink:href="#integration-direction-icon"></use>
        </svg>
      </div>
      <integration-card :integration="integration2" :simple="simple"/>
    </div>
  </loading-view>
</template>

<script>
import IntegrationCard from "@/components/Dashboard/IntegrationCard";

export default {
  name: 'TwoIntegrations',

  components: {
    IntegrationCard
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    integration1: {
      type: [Object, null],
      required: true,
    },

    integration2: {
      type: [Object, null],
      required: true,
    },

    simple: {
      type: Boolean,
      default: false,
    },
  }
};
</script>
